// @flow

import * as React from "react"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import {saveBaby} from "../../../actions/baby"
import {COUNTRIES} from "../../../constants"
import IntakeDataNav from "../../../components/intake/data-nav.js"
import Flatpickr from "react-flatpickr"
import {set, cloneDeep, debounce} from "lodash"
import type {
  State as ReduxState,
  Baby,
  FamilyUser,
  Dispatch,
  ValidationError,
} from "../../../types"

type Props = {
  t: any,
  dispatch: Dispatch,
  match: any,
  baby: Baby,
  isSaving: boolean,
}

type BabyEdit = any

type State = {
  errors: any,
  baby: BabyEdit,
  showMultiples: boolean,
}

type FlatpickrInstance = any

const requiredProps = ["users[1][firstname]"]

class IntakeDataGeneralView extends React.Component<Props, State> {
  handleInputChange: (SyntheticEvent<HTMLInputElement>) => void
  handleDateChange: ($ReadOnlyArray<Date>, string, FlatpickrInstance) => void
  handleToggleMultiples: (SyntheticEvent<HTMLLinkElement>) => void
  handleClearMultiple: (SyntheticEvent<HTMLLinkElement>, number) => void
  save: () => void
  // handleSubmit: (SyntheticEvent<>) => void

  constructor(props: Props) {
    super(props)
    this.state = {
      baby: props.baby,
      errors: {},
      showMultiples:
        (props.baby.sex_2 && props.baby.sex_2 !== "" ? true : false) ||
        (props.baby.sex_3 && props.baby.sex_3 !== "" ? true : false),
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleToggleMultiples = this.handleToggleMultiples.bind(this)
    this.handleClearMultiple = this.handleClearMultiple.bind(this)
    this.save = debounce(this.save.bind(this), 200, {
      leading: false,
      trailing: true,
    })
    // this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidUpdate(prevProps: Props) {
    const {baby} = this.props
    if (!prevProps.baby && baby) {
      this.setState({
        baby: this.createBabyEdit(baby),
        errors: {},
      })
    }
  }

  createBabyEdit(baby: Baby): BabyEdit {
    const {
      family: {users},
    } = baby
    return {
      ...baby,
      family: {
        ...baby.family,
        users: users.map((u) => ({...u})),
      },
    }
  }

  handleInputChange(e) {
    const target = e.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const name = target.name
    this.editBaby(name, value)
    // TODO dispatch dirty state
  }

  handleDateChange(
    dates: $ReadOnlyArray<Date>,
    dateStr: string,
    instance: FlatpickrInstance
  ) {
    dates.forEach((d) => d)
    this.editBaby(instance.element.name, dateStr)
  }

  editBaby(property: string, value: any) {
    // TODO
    // yes this is not really a functional style I know
    // but at least it mutates a copy
    const baby = cloneDeep(this.state.baby)
    set(baby, property, value)
    this.setState({baby}, () => this.save())
  }

  validate() {
    const {errors, baby} = this.state
    if (baby) {
      this.validateProperty("firstname", baby.firstname)

      if (errors != {}) {
        console.log("invalid form")
      }
    }
  }

  validateProperty(property: string, value: string) {
    let error = null
    if (value == "" && isRequired(property)) {
      error = {type: "required"}
    }
    if (error) {
      this.addError(property, error)
    } else {
      this.clearError(property)
    }
  }

  addError(fieldName: string, error: ValidationError) {
    const {errors} = this.state
    this.setState({errors: {...errors, [fieldName]: error}})
  }

  clearError(fieldName: string) {
    const {errors} = this.state
    const {[fieldName]: value, ...withoutError} = errors // eslint-disable-line no-unused-vars
    this.setState({
      errors: withoutError,
    })
  }

  hasError = (fieldName: string): boolean =>
    Object.keys(this.state.errors).includes(fieldName)

  showError(fieldName: string): ?React.Node {
    const error = this.state.errors[fieldName]
    if (error) {
      return <div className="has-error">{error.type}</div>
    }

    return null
  }

  save() {
    // this.validate()
    const {dispatch, baby} = this.props
    const edits = this.state.baby
    if (baby && edits) {
      dispatch(saveBaby(baby.token, edits))
    }
  }

  handleToggleMultiples(e: SyntheticMouseEvent<HTMLLinkElement>) {
    e.preventDefault()
    this.setState({showMultiples: !this.state.showMultiples})
  }

  handleClearMultiple(e: SyntheticEvent<HTMLLinkElement>, index: number) {
    e.preventDefault()
    this.setState({
      baby: {
        ...this.state.baby,
        ["sex_" + index]: "",
      },
    })
    this.save()
  }

  renderUserField(user, property, userIdx) {
    const {t} = this.props
    const name = `family.users[${userIdx}].${property}`
    return (
      <div className="form-group">
        <label htmlFor={name}>{t(`intake.data.general.${property}`)}*</label>
        <input
          className="form-control"
          name={name}
          id={name}
          type={property == "email" ? "email" : "text"}
          value={user[property] || ""}
          onChange={this.handleInputChange}
        />
        {this.hasError(property) && this.showError(property)}
      </div>
    )
  }

  renderAddressField(baby, property) {
    const {t} = this.props
    const name = `family.${property}`
    let field = null
    switch (property) {
      case "country":
        field = (
          <select
            className="form-control"
            value={baby.family[property] || ""}
            name={name}
            id={name}
            onChange={this.handleInputChange}
          >
            {COUNTRIES.map((c) => {
              return (
                <option key={`${property}-opt-${c}`} value={c}>
                  {t(`countries.${c}`)}
                </option>
              )
            })}
          </select>
        )
        break
      default:
        field = (
          <input
            className="form-control"
            name={name}
            id={name}
            type="text"
            value={baby.family[property] || ""}
            onChange={this.handleInputChange}
          />
        )
    }
    return (
      <div className="form-group">
        <label htmlFor={name}>{t(`intake.data.general.${property}`)}</label>
        {field}
        {this.hasError(property) && this.showError(property)}
      </div>
    )
  }

  renderUserEdit(user: FamilyUser, userIdx: number) {
    return (
      <div key={user.token} className="mb-4">
        <h2>Partner {userIdx + 1}</h2>
        <div className="row">
          <div className="col-md-6">
            {this.renderUserField(user, "firstname", userIdx)}
          </div>
          <div className="col-md-6">
            {this.renderUserField(user, "lastname", userIdx)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            {this.renderUserField(user, "email", userIdx)}
          </div>
          <div className="col-md-6">
            {this.renderUserField(user, "phone", userIdx)}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {t, isSaving} = this.props
    const {baby, showMultiples} = this.state
    if (!baby) {
      return null
    }
    return (
      <div className="container">
        <IntakeDataNav isSaving={isSaving} />

        <div>
          <div className="row">
            <div className="col-md-8 col-lg-6 col-xl-6">
              {baby.family.users.map((user, idx) =>
                this.renderUserEdit(user, idx)
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-6 col-xl-4">
              <h2>{t("intake.data.general.address")}</h2>

              <div className="row">
                <div className="col col-md-9">
                  {this.renderAddressField(baby, "street")}
                </div>
                <div className="col col-md-3">
                  {this.renderAddressField(baby, "nbr")}
                </div>
              </div>
              <div className="row">
                <div className="col col-md-3">
                  {this.renderAddressField(baby, "postalCode")}
                </div>
                <div className="col col-md-5">
                  {this.renderAddressField(baby, "city")}
                </div>
                <div className="col col-md-4">
                  {this.renderAddressField(baby, "country")}
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-4">
              <h2>{t("intake.data.general.baby")}</h2>
              <div className="row">
                <div className="col col-md-6">
                  <div className="form-group">
                    <label htmlFor="lastname">
                      {t("intake.data.general.lastname")}*
                    </label>
                    <input
                      className="form-control"
                      name="lastname"
                      id="lastname"
                      type="text"
                      value={baby.lastname || ""}
                      onChange={this.handleInputChange}
                    />
                    {this.hasError("lastname") && this.showError("lastname")}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="sex">
                      {t("intake.data.general.sex.label")}*
                    </label>
                    <select
                      className="form-control"
                      name="sex"
                      id="sex"
                      type="text"
                      value={baby.sex || ""}
                      onChange={this.handleInputChange}
                    >
                      <option value="m">
                        {t("intake.data.general.sex.m")}
                      </option>
                      <option value="f">
                        {t("intake.data.general.sex.f")}
                      </option>
                      <option value="u">
                        {t("intake.data.general.sex.u")}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col col-md-6">
                  <div className="form-group">
                    <a href="#" onClick={this.handleToggleMultiples}>
                      {t("intake.data.general.multiples.toggle")}
                    </a>
                  </div>
                </div>
              </div>
              {showMultiples ? (
                <React.Fragment>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="sex">
                          {t("intake.data.general.sex.label")}
                        </label>
                        <select
                          className="form-control"
                          name="sex_2"
                          id="sex_2"
                          type="text"
                          value={baby.sex_2 || ""}
                          onChange={this.handleInputChange}
                        >
                          <option>{t("intake.data.general.sex.none")}</option>
                          <option value="m">
                            {t("intake.data.general.sex.m")}
                          </option>
                          <option value="f">
                            {t("intake.data.general.sex.f")}
                          </option>
                          <option value="u">
                            {t("intake.data.general.sex.u")}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <a
                        href="#"
                        onClick={(e) => this.handleClearMultiple(e, 2)}
                      >
                        {t("intake.data.general.multiples.clear")}
                      </a>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="sex">
                          {t("intake.data.general.sex.label")}
                        </label>
                        <select
                          className="form-control"
                          name="sex_3"
                          id="sex_3"
                          type="text"
                          value={baby.sex_3 || ""}
                          onChange={this.handleInputChange}
                        >
                          <option>{t("intake.data.general.sex.none")}</option>
                          <option value="m">
                            {t("intake.data.general.sex.m")}
                          </option>
                          <option value="f">
                            {t("intake.data.general.sex.f")}
                          </option>
                          <option value="u">
                            {t("intake.data.general.sex.u")}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <a
                        href="#"
                        onClick={(e) => this.handleClearMultiple(e, 3)}
                      >
                        {t("intake.data.general.multiples.clear")}
                      </a>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="dueDate">
                      {t("intake.data.general.dueDate")}*
                    </label>
                    <Flatpickr
                      options={{
                        altFormat: "d/m/Y",
                        dateFormat: "Y-m-d",
                        altInput: true,
                      }}
                      value={baby.dueDate}
                      onChange={this.handleDateChange}
                      name="dueDate"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="family.childrenAmount">
                      {t("intake.data.general.childrenAmount")}*
                    </label>
                    <select
                      className="form-control"
                      name="family.childrenAmount"
                      id="family.childrenAmount"
                      type="text"
                      value={baby.family.childrenAmount || 1}
                      onChange={this.handleInputChange}
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </select>
                    {this.hasError("family.childrenAmount") &&
                      this.showError("family.childrenAmount")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-6">
              <h2>{t("intake.data.general.remarks")}</h2>
              <textarea
                className="form-control"
                value={baby.remarks || ""}
                rows={4}
                onChange={this.handleInputChange}
                name="remarks"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const isRequired = (property) => requiredProps.includes(property)

const mapStateToProps = (state: ReduxState) => ({
  baby: state.baby.baby,
  isSaving: state.baby.isBabySaving,
})

export default withTranslation()(
  connect(mapStateToProps)(IntakeDataGeneralView)
)
